import angular from "angular";

// import WikiMainPageController from './wiki_main_page/WikiMainPageController';
// import WikiDetailPageController from './wiki_detail_page/WikiDetailPageController';
// import WikiSettingsPageController from './wiki_settings_page/WikiSettingsPageController';
import createEditWikiSectionFactory from './wiki_main_page/createEditSectionFactory/factory';
import WikiResource from './wiki_main_resource';
import WikiSectionResource from './wiki_main_page/wiki_section_resource';
import WikiSlideResource from './wiki_detail_page/wiki_slide_resource';
import WikiMembershipResource from './wiki_settings_page/wiki_membership_resource';
// import WikiManageSlide from './wiki_detail_page/WikiManageSlide';
import wikiShareFactory from "./wiki_detail_page/wiki_sharing/wikiShareFactory";
//detail
// import wikiEmptySlide from './wiki_detail_page/wiki_empty_slide_directive/directive';
// import wikiSliderPanel from './wiki_detail_page/wiki_slider_panel_directive/directive';
// import wikiSlideRenderContainer from "./wiki_detail_page/wiki_slide_render_container_directive/directive";
// import wikiSlideButtonsPanel from "./wiki_detail_page/wiki_slide_buttons_panel_directive/directive";
// import wikiSlideHeader from "./wiki_detail_page/wiki_slide_header_directive/directive";
import likesResourceFactory from "../shared/common/likesResourceFactory";
// import wikiSlideDescription from "./wiki_detail_page/wiki_slide_description_directive/directive";
// import wikiSlideAttachments from "./wiki_detail_page/wiki_slide_attachments_directive/directive";
import WikiSlideLinkedGoalsResource from "./wiki_detail_page/wiki_slide_linked_goals";
// import wikiBreadcrumbs from "./wiki_breadcrumbs/wiki_breadcrumbs_directive";
import wikiSharingResourceFactory from "./wiki_detail_page/wiki_sharing/sharing_resource_factory";
import WikisListResource from "./wikis_list_resource";
import CommentsInfiniteScrollResourceFactory from "../shared/comments/resource_infinite_scroll_factory";
import WikiBindController from "../wiki_page/WikiBindController";
import WikiTemplatesResource from "./WikiTemplatesResource";



angular.module('mmApp')
    .controller('WikiBindController', WikiBindController)


    // .controller('WikiMainPageController', WikiMainPageController)
    // .controller('WikiDetailPageController', WikiDetailPageController)
    .factory('createEditWikiSectionFactory', createEditWikiSectionFactory)
    .factory('WikiResource', WikiResource)
    .factory('WikiTemplatesResource', WikiTemplatesResource)
    .factory('WikiSectionResource', WikiSectionResource)
    .factory('WikiSlideResource', WikiSlideResource)
    // .factory('WikiManageSlide', WikiManageSlide)
    .factory('WikiSlideLinkedGoalsResource', WikiSlideLinkedGoalsResource)
    .factory('wikiShareFactory', wikiShareFactory)
    .factory('WikiSlideSharingResource', wikiSharingResourceFactory('wiki_slide_sharing'))
    .factory('WikiSectionSharingResource', wikiSharingResourceFactory('wiki_section_sharing'))
    .factory('WholeWikiSharingResource', wikiSharingResourceFactory('wiki_whole_sharing'))
    .factory('WikiMembershipResource', WikiMembershipResource)
    .factory('WikiSlideLikesResource', likesResourceFactory('wiki_slide_likes'))
    .factory('WikisListResource', WikisListResource)
    // .directive('wikiEmptySlide', wikiEmptySlide)
    // .directive('wikiSliderPanel', wikiSliderPanel)
    // .directive('wikiSlideRenderContainer', wikiSlideRenderContainer)
    // .directive('wikiSlideButtonsPanel', wikiSlideButtonsPanel)
    // .directive('wikiSlideHeader', wikiSlideHeader)
    // .directive('wikiSlideDescription', wikiSlideDescription)
    // .directive('wikiSlideAttachments', wikiSlideAttachments)
    // .directive('wikiBreadcrumbs', wikiBreadcrumbs)
;


export default 'mmApp.wiki';
